import { render, staticRenderFns } from "./c-detail.vue?vue&type=template&id=17db3e2a&"
import script from "./c-detail.vue?vue&type=script&lang=js&"
export * from "./c-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports